import { render, staticRenderFns } from "./PoliticsPage.vue?vue&type=template&id=6c3ff5c8&scoped=true&"
import script from "./PoliticsPage.vue?vue&type=script&lang=js&"
export * from "./PoliticsPage.vue?vue&type=script&lang=js&"
import style0 from "./PoliticsPage.vue?vue&type=style&index=0&id=6c3ff5c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3ff5c8",
  null
  
)

export default component.exports